import type { AppState } from "./AppState"
import { saveState } from "./persistence"

type Listener = (state: AppState) => void

export class StateStore {
  private state: AppState
  private listeners: Set<Listener> = new Set()

  constructor(initialState: AppState) {
    this.state = initialState
  }

  getState(): AppState {
    return this.state
  }

  replace(nextState: AppState): void {

      this.apply(
          nextState,
          true
      );

  }

  private apply(
        next: AppState,
        notify: boolean
    ): void {

        this.state = next;

        this.persist();

        if (notify) {
            this.notify();
        }

    }

  update(updater: (prev: AppState) => AppState): void {

      const next =
          updater(this.state);

      if (next === this.state) {
          throw new Error(
              "StateStore.update must return a new state object"
          );
      }

      this.apply(
          next,
          true
      );

  }

  public updateSilently(
        updater: (
            prev: AppState
        ) => AppState
    ): void {

        const next =
            updater(this.state);

        if (next === this.state) {
            throw new Error(
                "StateStore.updateSilently must return a new state object"
            );
        }

        this.apply(
            next,
            false
        );

    }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener(this.state)
    }
  }

  /**
   * V6 SAFE PERSISTENCE
   * Сохраняем только UI-локальные данные.
   * Никаких серверных state-machine значений.
   */
  private persist(): void {
    const {
      currentKrokId,
      gaps,
      revealed,
      scrollY
    } = this.state

    console.log("SAVE", {
      currentKrokId,
      gaps,
      revealed,
      scrollY
    })

    saveState({
      currentKrokId,
      gaps,
      revealed,
      scrollY
    })
  }
}
